import { OrganizationDto } from "@asd-stan/ballot/api/organization/organization.dto";
import { Organization } from "@asd-stan/ballot/domain/organization.entity";

export const makeOrganizationFromOrganizationDTO = (dto: OrganizationDto): Organization => {
	return new Organization({
		id: dto.id,
		name: dto.name,
	});
};
